module.exports = __webpack_public_path__ + "public/SiteImages/noWishList.svg?8aa6e37b";